<template>
  <div class="advance-search" v-loading="loadLoading">
    <div class="advance-search-left">
      <pageForm ref="pageForm" :title="$i18n.$t('高级检索')" :btnName="$i18n.$t('人物检索')" :fields="fields" @search="search" />
    </div>
    <div class="advance-search-right" style="position: relative;">
      <div class="advance-search-right-title">
        <div class="advance-search-right-title-left">{{ $i18n.$t('检索结果') }}</div>
        <div class="advance-search-right-title-right">
          <el-checkbox :disabled="!listData.list.length" v-model="checkedAll" @change="checkedAllChange">{{ $i18n.$t('全选') }}</el-checkbox>
          <el-button type="primary" @click.stop="exportData" :disabled="!listData.list.length || !checked.length || downloadLoading" :loading="downloadLoading">{{ $i18n.$t('导出数据') }}</el-button>
        </div>
      </div>
      <div class="page-common-container-right-content-no-data" v-if="listData.total === 0">
        <img src="@/assets/map/no-data.png" alt="">
        <p>{{ $i18n.$t('没有查询到相关的记录') }}</p>
      </div>
      <template v-else>
        <el-checkbox-group v-model="checked" @change="checkedChange">
          <div class="advance-search-right-content">
            <div class="advance-search-right-content-row" v-for="(row, index) in listData.list" :key="index">
              <div class="advance-search-right-content-row-top">
                <div class="advance-search-right-content-row-top-header">
                  <el-checkbox :label="row.Id">{{ row.Name }}</el-checkbox>
                  <div class="advance-search-right-content-row-top-header-label">
                    <div @click.stop="navToSocialRelations(row)">{{ $i18n.$t('社会关系') }}<i class="el-icon-arrow-right"></i></div>
                    <div @click.stop="navToMentorshipRelations(row)">{{ $i18n.$t('师承关系') }}<i class="el-icon-arrow-right"></i></div>
                    <div @click.stop="navToFootprints(row)">{{ $i18n.$t('人物足迹') }}<i class="el-icon-arrow-right"></i></div>
                    <div @click.stop="navToBiographical(row)">{{ $i18n.$t('传记记载') }}<i class="el-icon-arrow-right"></i></div>
                  </div>
                </div>
                <div class="advance-search-right-content-row-top-desc">{{ $i18n.$t('人物别名：') }}{{ row.Alias.join(',') }}</div>
              </div>
              <div class="advance-search-right-content-row-item">
                <div class="advance-search-right-content-row-item-title">{{ $i18n.$t('基本信息') }}</div>
                <div class="advance-search-right-content-row-item-rowGroup">
                  <div>{{ $i18n.$t('性别：') }}
                    <span v-if="row.Gender === '1'">{{ $i18n.$t('男') }}</span>
                    <span v-else-if="row.Gender === '2'">{{ $i18n.$t('女') }}</span>
                    <span v-else>{{ $i18n.$t('未知') }}</span>
                  </div>
                  <div>{{ $i18n.$t('朝代：') }}{{ row.Dynasty }}</div>
                  <div>{{ $i18n.$t('分类：') }}{{ row.Category }}</div>
                  <div>{{ $i18n.$t('宗派：') }}{{ row.Sect }}</div>
                  <div>{{ $i18n.$t('出生时间：') }}{{ row.Birthday }}</div>
                  <div>{{ $i18n.$t('逝世时间：') }}{{ row.Deathday }}</div>
                  <div>{{ $i18n.$t('籍贯：') }}{{ (row.native_place || []).join(',') }}</div>
                  <div>{{ $i18n.$t('驻锡地：') }}{{ (row.work_place || []).join(',') }}</div>
                </div>
              </div>
              <div class="advance-search-right-content-row-item">
                <div class="advance-search-right-content-row-item-title">{{ $i18n.$t('简介') }}</div>
                <div class="advance-search-right-content-row-item-desc">{{ row.Introduction }}</div>
              </div>
              <div class="advance-search-right-content-row-item">
                <div class="advance-search-right-content-row-item-title">{{ $i18n.$t('扩展介绍') }}</div>
                <div class="advance-search-right-content-row-item-desc">{{ row.ExtendedIntroduction }}</div>
              </div>
              <div class="advance-search-right-content-row-item" v-if="row.RecordedInfo">
                <div class="advance-search-right-content-row-item-title">{{ $i18n.$t('记载出处') }}</div>
                <div class="advance-search-right-content-row-item-desc">{{ row.RecordedInfo.join('、') }}</div>
              </div>
              <!-- <div class="advance-search-right-content-row-item">
                <div class="advance-search-right-content-row-item-title">著作列表</div>
                <div class="advance-search-right-content-row-item-desc">{{ row.Works.join('、') }}</div>
              </div> -->
              <!-- <div class="advance-search-right-content-row-item">
                <div class="advance-search-right-content-row-item-title">研究文献</div>
                <div class="advance-search-right-content-row-item-desc">{{ row.ResearchLiterature }}</div>
              </div> -->
              <div class="advance-search-right-content-row-item">
                <div class="advance-search-right-content-row-item-title">{{ $i18n.$t('原文') }}</div>
                <div class="advance-search-right-content-row-item-desc" v-html="row.OriginalText.replace(/\n/g, '<br />')"></div>
              </div>
              <div class="advance-search-right-content-row-item">
                <div class="advance-search-right-content-row-item-title">{{ $i18n.$t('白话文') }}</div>
                <div class="advance-search-right-content-row-item-desc" v-html="row.VernacularText.replace(/\n/g, '<br />')"></div>
              </div>
            </div>
          </div>
        </el-checkbox-group>
        <div class="advance-search-right-page">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="params.page"
            :page-sizes="[100, 200, 300, 400]"
            :page-size.sync="params.limit"
            layout="total, prev, pager, next"
            :total="listData.total">
          </el-pagination>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { advancedSSearch } from '@/api/home'
import { advancedSearchOutput } from '@/api/export'
import { i18n } from '@/i18n'
export default {
  name: 'AdvanceSearch',
  meta: {
    title: i18n.$t('高级搜索')
  },
  data () {
    let sessionParams = sessionStorage.getItem('advancedSearchParams')
    if (sessionParams) {
      sessionParams = JSON.parse(sessionParams)
    }
    return {
      fields: [
        {
          type: 'person',
          label: i18n.$t('人物名称'),
          placeholder: i18n.$t('请输入想要了解的人物'),
          key: 'Name',
          defaultValue: sessionParams ? (sessionParams.Name || '') : null
        },
        {
          type: 'select',
          label: i18n.$t('人物分类'),
          placeholder: i18n.$t('全部'),
          key: 'Category',
          clearable: true,
          options: this.$store.state.dict.personCategory || [],
          defaultValue: sessionParams ? (sessionParams.Category || '') : null
        },
        {
          type: 'select',
          label: i18n.$t('传记名称'),
          placeholder: i18n.$t('全部'),
          key: 'Biographie',
          clearable: true,
          options: this.$store.state.dict.biographieName || [],
          defaultValue: sessionParams ? (sessionParams.Biographie || '') : null
        },
        {
          type: 'select',
          label: i18n.$t('宗派'),
          placeholder: i18n.$t('全部'),
          key: 'Sect',
          clearable: true,
          options: this.$store.state.dict.allSect || [],
          defaultValue: sessionParams ? (sessionParams.Sect || '') : null
        },
        {
          type: 'selectGroup',
          label: i18n.$t('时间'),
          separator: i18n.$t('至'),
          start: {
            placeholder: i18n.$t('全部'),
            key: 'Dynasty_start',
            options: this.$store.state.dict.allDynasty || [],
            defaultValue: sessionParams ? (sessionParams.Dynasty_start || '') : null
          },
          end: {
            placeholder: i18n.$t('全部'),
            key: 'Dynasty_end',
            options: this.$store.state.dict.allDynasty || [],
            defaultValue: sessionParams ? (sessionParams.Dynasty_end || '') : null
          }
        // },
        // {
        //   type: 'input',
        //   label: '人物著作',
        //   placeholder: '请输入想要了解的人物著作',
        //   key: 'Works'
        },
        {
          type: 'select',
          label: i18n.$t('人物设置'),
          placeholder: i18n.$t('请选择'),
          key: 'is_extension',
          clearable: true,
          options: [
            { label: i18n.$t('显示所有人物'), value: '1' },
            { label: i18n.$t('仅显示传记人物'), value: '0' }
          ],
          defaultValue: '1'
        }
      ],
      params: {
        page: 1,
        limit: 10
      },
      listData: {
        total: 0,
        list: []
      },
      checked: [],
      checkedAll: false,
      loadLoading: false,
      downloadLoading: false
    }
  },
  created () {
    const params = this.$route.query
    if (params && params.searchKey) {
      this.$set(this.fields[0], 'defaultValue', params.searchKey)
    }
    let sessionParams = sessionStorage.getItem('advancedSearchParams')
    if (sessionParams) {
      sessionParams = JSON.parse(sessionParams)
    }
    if (!sessionParams || (sessionParams && !sessionParams.Name)) {
      this.getAdvancedSSearch()
    }
  },
  methods: {
    exportData () {
      if (this.checked.length === 0) {
        this.$message.error(i18n.$t('请选择需要导出的数据'))
        return
      }
      this.downloadLoading = true
      advancedSearchOutput({
        ids: this.checked
      }).then(res => {
        const a = document.createElement('a')
        a.href = URL.createObjectURL(res)
        a.download = i18n.$t('高级搜索.xlsx')
        a.click()
        URL.revokeObjectURL(a.href)
      }).finally(() => {
        this.downloadLoading = false
      })
    },

    navToSocialRelations (row) {
      localStorage.setItem('socialRelationsName', row.Name)
      // this.$router.push({
      //   path: '/socialRelations'
      // })
      window.open(this.$router.resolve('/socialRelations').href, '_blank')
    },
    navToMentorshipRelations (row) {
      localStorage.setItem('mentorshipRelationsName', row.Name)
      // this.$router.push({
      //   path: '/mentorshipRelations'
      // })
      window.open(this.$router.resolve('/mentorshipRelations').href, '_blank')
    },
    navToFootprints (row) {
      localStorage.setItem('footprintsName', row.Name)
      // this.$router.push({
      //   path: '/footprints'
      // })
      window.open(this.$router.resolve('/footprints').href, '_blank')
    },
    navToBiographical (row) {
      localStorage.setItem('biographicalName', row.Name)
      // this.$router.push({
      //   path: '/biographical'
      // })
      window.open(this.$router.resolve('/biographical').href, '_blank')
    },
    checkedAllChange () {
      const ids = this.listData.list.map(e => e.Id)
      if (this.checkedAll) {
        ids.forEach(id => {
          if (!this.checked.includes(id)) {
            this.checked.push(id)
          }
        })
        // this.checked = this.listData.list.map(e => e.Id)
      } else {
        // this.checked = []
        ids.forEach(id => {
          const index = this.checked.indexOf(id)
          if (index !== -1) {
            this.checked.splice(index, 1)
          }
        })
      }
    },
    checkedChange () {
      if (this.checked.length === this.listData.list.length) {
        this.checkedAll = true
      } else {
        this.checkedAll = false
      }
    },
    search (params) {
      this.params = {
        ...this.params,
        ...params
      }
      sessionStorage.setItem('advancedSearchParams', JSON.stringify(params))
      this.getAdvancedSSearch(params)
    },
    getAdvancedSSearch (params) {
      const query = {
        ...this.params,
        ...(params || {})
      }
      this.loadLoading = true
      advancedSSearch(query).then(res => {
        const { data, pagination } = res.data
        this.listData.list = data
        this.listData.total = pagination.total_items
        this.checkedAll = this.listData.list.map(e => e.Id).every(id => this.checked.includes(id))
      }).finally(() => {
        this.loadLoading = false
      })
    },
    handleSizeChange () {
      this.params.page = 1
      this.getAdvancedSSearch()
    },
    handleCurrentChange () {
      this.getAdvancedSSearch()
    }
  }
}
</script>
